import { PlatformLocalUser } from '@cloudquery/api-platform';
import { paths } from 'shared/base';

export function getConditionalRoutes(user: PlatformLocalUser | undefined) {
  return [
    {
      isAllowed: user?.roles?.some((role) => role.includes('admin')),
      path: paths.platform.settings.organization.settings,
    },
    {
      isAllowed: user?.roles?.some((role) => role.includes('admin')),
      path: paths.platform.settings.organization.users,
    },
  ];
}
